"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatsigInternalClientFactoryBootstrap = void 0;
const react_1 = require("react");
function useStatsigInternalClientFactoryBootstrap(factory, args) {
    const clientRef = (0, react_1.useRef)(null);
    return (0, react_1.useMemo)(() => {
        if (clientRef.current) {
            return clientRef.current;
        }
        const inst = factory(args);
        clientRef.current = inst;
        inst.dataAdapter.setData(args.initialValues);
        inst.initializeSync();
        return inst;
    }, []);
}
exports.useStatsigInternalClientFactoryBootstrap = useStatsigInternalClientFactoryBootstrap;
